import setupPlanyoForm from './modules/validation/planyo-form.js';
import setupPlanyoFormUI from './modules/planyo-form-ui.js';

setupPlanyoForm();
setupPlanyoFormUI();